import { Navigate, Outlet } from "react-router-dom";
import { isLoggedIn } from "../utils/auth";

export default function PublicRoute() {
  return !isLoggedIn()
    ? <Outlet />
    : <Navigate to="/studentdashboard" replace />;
}